/**
 * Scrubs a title to make it compliant for document filenames
 * Replaces invalid characters with underscores
 *
 * @param title - The title to scrub
 * @returns A scrubbed title safe for use in filenames
 */
export function scrubTitleForDocument(title: string): string {
  if (!title || title === "Untitled Document") {
    return title;
  }

  // Replace invalid filename characters with underscores
  // Invalid characters: / \ : * ? " < > |
  return title
    .replace(/[/\\:*?"<>|]/g, "_")
    .replace(/\s+/g, "_") // Replace spaces with underscores
    .replace(/_+/g, "_") // Replace multiple underscores with single underscore
    .replace(/^_|_$/g, ""); // Remove leading/trailing underscores
}

/**
 * Checks if a title is valid for document saving
 *
 * @param title - The title to check
 * @returns true if the title is valid for saving
 */
export function isTitleValidForSaving(title: string): boolean {
  return !!(title && title.trim() !== "");
  // return !!(title && title.trim() !== "" && title !== "Untitled Document");

}
